module.exports = __webpack_public_path__ + "media/images/emblems/Eich_LU-235b63f6446d141d66b94548e9117325.png";